import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ocrStorageService } from 'services';
import { parseApiError } from 'utils/errorParser';
import { notify } from 'features/ui/uiSlice';

export const fetchOcrStorage = createAsyncThunk('ocrStorage/fetch', async (params, { rejectWithValue }) => {
  try {
    return await ocrStorageService.fetchArticles(params);
  } catch (error) {
    return rejectWithValue(parseApiError(error));
  }
});

export const manualUploadOCR = createAsyncThunk('ocrStorage/manualUploadOCR', async (formData, { dispatch, rejectWithValue }) => {
  try {
    const article = await ocrStorageService.manualUploadOCR(formData);
    dispatch(fetchOcrStorage());
    return article;
  } catch (error) {
    const parsed = parseApiError(error);
    dispatch(notify({ type: 'error', message: parsed.message }));
    return rejectWithValue(parsed);
  }
});

const ocrStorageSlice = createSlice({
  name: 'ocrStorage',
  initialState: { items: [], meta: { page: 1, totalPages: 1, total: 0 }, status: 'idle', saving: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOcrStorage.pending, (state) => { state.status = 'loading'; })
      .addCase(fetchOcrStorage.fulfilled, (state, action) => { 
        state.status = 'succeeded'; 
        state.items = action.payload.items; 
        state.meta = {
          page: action.payload.page,
          totalPages: action.payload.totalPages,
          total: action.payload.total,
        };
      })
      .addCase(fetchOcrStorage.rejected, (state, action) => { state.status = 'failed'; state.error = action.payload?.message; })
      .addCase(manualUploadOCR.pending, (state) => { state.saving = true; })
      .addCase(manualUploadOCR.fulfilled, (state) => { state.saving = false; })
      .addCase(manualUploadOCR.rejected, (state) => { state.saving = false; });
  },
});

export default ocrStorageSlice.reducer;
